export const formatApplicationDetailsData = (property, value) => {
    if (property === 'amount') {
        return value + '/-';
    }
    if (property === 'documentList') {
        return (
            <ol className="document-list">
                {value.map((document, index) => {
                    const label = typeof document === 'string'
                        ? document
                        : (document.name || document.fileName || 'Document');
                    return <li key={index}>{`${index + 1}. ${label}`}</li>;
                })}
            </ol>
        );
    }
    if(property === 'cscCenterMobile') {
        return `+91-${value}` 
    }
    return value;
}